export type SalesStatusRow = { date: string; contract: number; deposit: number; refund: number; balance: number; empty?: boolean }

// 비식별 통계 화면용 Mock. 실제 매출·지점·계약 데이터와 연결하지 않는다.
export const legacyDailySalesRows: SalesStatusRow[] = [
  { date: '2026-08-20', contract: 480000, deposit: 280000, refund: 0, balance: 200000 },
  { date: '2026-08-19', contract: 0, deposit: 0, refund: 0, balance: 0, empty: true },
]

export const legacyMonthlySalesRows = [
  { month: '2026-08', category: 'Mock 유입 A', detail: 'Mock 구분 A', contract: 480000, deposit: 280000 },
  { month: '2026-08', category: 'Mock 고객구분', detail: 'Mock 구분 B', contract: 0, deposit: 0, empty: true },
]
